import {homepage} from "../constants/constants";
import Table from "../pages/Table/Table";
import Schedule from "../pages/Schedule/Schedule";
import Personal from "../pages/Personal/Personal";
import PersonalHeader from "../components/Header/PersonalHeader/PersonalHeader";
import AppHeader from "../components/Header/AppHeader/AppHeader";

export const routes = [
    {path: `${homepage}`, element: <><AppHeader /> <Table/></>, exact: true},
	{path: `${homepage}/:recordId`, element: <><AppHeader /> <Table/></>, exact: true},
	{path: `${homepage}/schedule/`, element: <><AppHeader /> <Schedule/></>, exact: true},
    {path: `${homepage}/schedule/specialist/:specialistId`, element: <><AppHeader /> <Schedule/></>, exact: true},
    {path: `${homepage}/schedule/clinic/:salonId`, element: <><AppHeader /> <Schedule/></>, exact: true},
    {path: `${homepage}/schedule/slot/:slotId`, element: <><AppHeader /> <Schedule/></>, exact: true},
    {path: `${homepage}/schedule/alt-slot/:altSlotId`, element: <><AppHeader /> <Schedule/></>, exact: true},
]

export const specialistRoutes = [
    {path: `${homepage}`, element: <><PersonalHeader /> <Personal/></>, exact: true},
]